module.exports = __webpack_public_path__ + "static/img/coin.29ee3f47.svg";